import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { LightRaysCore } from './LightRaysCore';
import { chatStore } from '~/lib/stores/chat';
import { themeStore } from '~/lib/stores/theme';

export const LightRays = memo(({ className }: { className?: string }) => {
  const theme = useStore(themeStore);
  const chatStarted = useStore(chatStore.started);

  return <LightRaysCore className={className} theme={theme} chatStarted={chatStarted} />;
});
